module.exports = __webpack_public_path__ + "static/media/faq-turnos.066657e6.png";